import React, { useEffect } from "react";

/**
 * Sur certains déploiements, /medecin/index.html est servi par le fallback SPA React sans route dédiée.
 * On renvoie vers l’espace médecin Port-Royal (/portail-medecin), pas vers l’ancien tableau HTML multisecteur.
 */
export default function MedecinMultisecteurPortalRedirect() {
  useEffect(() => {
    window.location.replace(
      `/portail-medecin${window.location.search || ""}${window.location.hash || ""}`
    );
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        color: "#374151",
        padding: 24,
        textAlign: "center",
      }}
    >
      <p>Redirection vers votre espace médecin…</p>
    </div>
  );
}
